import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

export default function AlertPrefs() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me/notification-prefs").then(({ data }) => setD(data)); }, []);
  if (!d) return null;
  const put = async (patch) => { try { const { data } = await api.put("/me/notification-prefs", patch); setD(data); } catch (e) { toast.error(errMsg(e)); } };
  const hasEmail = d.email_types.length > 0;
  return (
    <section className="q-card mt-6 space-y-3" data-testid="alert-prefs">
      <h2 className="font-display text-lg font-bold text-q-text">What to tell me about</h2>
      <div className="grid grid-cols-[1fr_auto_auto_auto] items-center gap-x-4 gap-y-1 text-sm">
        <span /><span className="text-[10px] font-black uppercase tracking-[0.14em] text-q-faint">In app</span>
        <span className="text-[10px] font-black uppercase tracking-[0.14em] text-q-faint">{hasEmail ? "Email" : ""}</span>
        <span className="text-[10px] font-black uppercase tracking-[0.14em] text-q-faint">Push</span>
        {Object.entries(d.types).map(([t, label]) => (
          <div key={t} className="contents" data-testid={`alert-pref-row-${t}`}>
            <span className="min-h-[44px] min-w-0 py-3 font-semibold text-q-text">{label}</span>
            <Switch checked={d.inapp[t]} onCheckedChange={(v) => put({ inapp: { [t]: v } })} data-testid={`alert-pref-inapp-${t}`} aria-label={`${label} in app`} />
            {hasEmail && d.email_types.includes(t) ? <Switch checked={d.email[t]} onCheckedChange={(v) => put({ email: { [t]: v } })} data-testid={`alert-pref-email-${t}`} aria-label={`${label} email`} /> : <span />}
            <Switch checked={d.push?.[t] ?? true} onCheckedChange={(v) => put({ push: { [t]: v } })} data-testid={`alert-pref-push-${t}`} aria-label={`${label} push`} />
          </div>
        ))}
      </div>
      {hasEmail && (
        <div className="flex flex-wrap items-center gap-2 border-t border-q-line pt-3" data-testid="alert-pref-chore-wish-email">
          <span className="text-sm font-semibold text-q-text">Kids Corner emails (chores and wishes):</span>
          {[["digest", "One email at 6 PM"], ["instant", "Right away"]].map(([v, l]) => (
            <button key={v} onClick={() => put({ chore_wish_email: v })} aria-pressed={d.chore_wish_email === v} data-testid={`alert-pref-chore-wish-${v}`}
              className={`min-h-[44px] rounded-full border px-3 text-sm font-semibold ${d.chore_wish_email === v ? "border-transparent bg-q-text text-q-bg" : "border-q-line text-q-muted"}`}>{l}</button>
          ))}
        </div>
      )}
      <p className="text-xs text-q-faint">Push goes to phones and browsers where you've turned on notifications. Turning push off for a type still keeps the in-app alert. Money emails go only to people with Money access. Message emails are sent if a message is still unread after 30 minutes, at most once an hour per conversation.</p>
    </section>
  );
}
